
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.6 1.143h10.8c.16 0 .312-.06.424-.168A.558.558 0 0012 .571a.558.558 0 00-.176-.404A.616.616 0 0011.4 0H.6C.44 0 .288.06.176.167A.558.558 0 000 .571c0 .152.063.297.176.404a.616.616 0 00.424.168zm10.8 5.714H.6c-.16 0-.312.06-.424.168A.558.558 0 000 7.429c0 .151.063.296.176.404A.616.616 0 00.6 8h10.8c.16 0 .312-.06.424-.167A.558.558 0 0012 7.429a.558.558 0 00-.176-.404.616.616 0 00-.424-.168zm0-2.286H.6c-.16 0-.312.06-.424.168A.558.558 0 000 5.143c0 .151.063.297.176.404a.616.616 0 00.424.167h10.8c.16 0 .312-.06.424-.167A.558.558 0 0012 5.143a.558.558 0 00-.176-.404.616.616 0 00-.424-.168zm0-2.285H.6c-.16 0-.312.06-.424.167A.558.558 0 000 2.857c0 .152.063.297.176.404A.616.616 0 00.6 3.43h10.8c.16 0 .312-.06.424-.168A.558.558 0 0012 2.857a.558.558 0 00-.176-.404.616.616 0 00-.424-.167z","fill":"#000"}})])
          )
        }
      }
    